import { type ApiBaseError } from './shared';

const binaryGetFetcher = async (url: string) => {
  const headers = new Headers();
  headers.append('Content-Type', 'application/pdf');

  const response = await fetch(url, {
    credentials: 'include',
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    const error: ApiBaseError = new Error('An error occurred while fetching the data.');
    error.status = response.status;
    throw error;
  }

  return response.blob();
};

export default binaryGetFetcher;
